import { render, staticRenderFns } from "./blacklistManage.vue?vue&type=template&id=2a1def22&"
import script from "./blacklistManage.vue?vue&type=script&lang=js&"
export * from "./blacklistManage.vue?vue&type=script&lang=js&"
import style0 from "./blacklistManage.vue?vue&type=style&index=0&id=2a1def22&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports